<template>
  <div class="app-background">
    <NewNavBar>
      <template slot="menuAdm">
        <MenuAreaAdm />
      </template>
      <template slot="menu">
        <Menu :key="getUser()" :userImage="userImage" />
      </template>
    </NewNavBar>
    <Content v-show="globalLoading == 0 && globalShowInfoError == 0" :key="getUser()" />

    <transition name="fade">
      <div v-if="globalLoading > 0" class="loading-block-container">
        <RotateSquare />
        <div>
          <p>Aguarde...</p>
        </div>
      </div>

      <div v-if="globalShowInfoError > 0" class="loading-block-container">
        <div class="config-body">
          <div>
            <div class="div-img">
              <div class="img"></div>
            </div>

            <p class="T14 mt-4">
              Parece que a busca pelas informações levou mais tempo do que o
              esperado!
            </p>
            <p class="T14">
              Estamos investigando o ocorrido. Por favor, tente novamente mais
              tarde.
            </p>
            <div class="config-button">
              <b-button @click="onActioHandler()" class="button" variant="primary" id="ok">Ok, entendi!
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <ProfileImageModal @image-updated="handleImageUpdate" />
    <ChangePasswordModal />

    <ChatWhatsapp v-if="showWhatsApp && !isLoginPage" class="chat-whatsapp-floating" />

    <CommunicationPassword v-if="!isAdmin && !isLoginPage" />

    <!-- Passo 1: Tour -->
    <WelcomeTourModal 
      v-if="currentStep === 'TOUR' && !isLoginPage" 
      ref="welcomeTourModal" 
      @start-tour="onStartTour" 
      @skip-tour="onSkipTour" 
    />

    <!-- Passo 2: Guia Médico  -->
    <Communication 
      v-if="currentStep === 'MEDICAL_GUIDE' && !isLoginPage"
      modalId="communication-modal" 
      @flow-next="handleMedicalGuideNext"
    />

    <!-- Passo 2: Popups (comunicado) -->
    <CommunicationPopUpModal 
      v-if="currentStep === 'POPUP' && !isLoginPage"
      :value="true" 
      :data="popups"
      modalId="communication-popup-modal"
      @input="onPopupClosed"
    />
  </div>
</template>

<script>
import NewNavBar from "../components/base/NewNavBar.vue";
import ChatWhatsapp from "../components/chat-whatsapp/ChatWhatsapp.vue";
import Content from "../components/base/Content.vue";
import { provide, ref } from "@vue/composition-api";
import ProfileImageModal from "../modules/user-profile-management/components/profile-image-upload/ProfileImageModal.vue";
import ChangePasswordModal from "../modules/user-profile-management/components/change-password/ChangePasswordModal.vue";
import Menu from "./Menu.vue";
import RotateSquare from "../components/rotate-square/RotateSquare.vue";
import getProfileImage from "../services/profile-image/profile-image-services.js";
import Communication from "../modules/communication/views/Communication.vue";
import WelcomeTourModal from "../modules/tour/WelcomeTourModal.vue";
import { startGuidedTour } from "../modules/tour/GuidedTourService.js";
import CommunicationPassword from "../modules/communication-password/views/CommunicationPassword.vue";
import MenuAreaAdm from "../components/base/MenuAreaAdm.vue";
import { getNameUser } from "../utils/user/user";
import { mapState } from "vuex"; 
import CommunicationPopUpModal from "../components/base-modals/CommunicationPopUpModal.vue";

export default {
  name: "base-layout-new-menu",
  components: {
    Content,
    NewNavBar,
    ProfileImageModal,
    ChangePasswordModal,
    Menu,
    RotateSquare,
    ChatWhatsapp,
    Communication,
    MenuAreaAdm,
    CommunicationPassword,
    WelcomeTourModal,
    CommunicationPopUpModal
  },
  data() {
    return {
      userImage: null,
      showRightModal: false,
      showWhatsApp: true,      
      // Estados possíveis: 'LOADING', 'TOUR', 'MEDICAL_GUIDE', 'POPUP', 'FINISHED'
      currentStep: 'LOADING', 
    };
  },
  computed: {
    ...mapState({
      popups: state => state.login.popups,
      popupAlreadyShown: state => state.login.popupAlreadyShown,
      user: state => state.login.user,      
    }),
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isLoginPage() {
      return this.$route.name === "login" || this.$route.path === "/login";
    },
    hasPopUp() {
      return this.popups && this.popups.id;
    },  
  },
  mounted() {
    this.atualizarBadgeRecaptcha();
    this.getUserImage();
    
     // Só inicia o fluxo se NÃO estiver na página de login
    if (!this.isLoginPage) {
      if (!this.isAdmin) {
        this.checkTour();
      } else {
        this.currentStep = 'MEDICAL_GUIDE'; 
      }
    } else {
      this.currentStep = 'LOADING'; // Mantém neutro no login
    }    

    if (this.$store.getters.getToken && !this.$store.state.login.popupAlreadyShown && !this.isAdmin) {
      this.$store.dispatch("loadPopUps");
    }
  },
  updated() { },
  watch: {
    popups: {
      handler(newValue) {
        if (newValue && newValue.id && this.currentStep === 'FINISHED' && !this.popupAlreadyShown) {
          this.currentStep = 'POPUP';
        }
      },
      deep: true
    },
    currentStep(newStep) {
      if (newStep === 'POPUP') {
        this.showPopUpModal();
      }
    },   
    estaLogado() {
      this.atualizarBadgeRecaptcha();
    },
  },
  beforeUnmount() {
    document.body.classList.remove("show-recaptcha");
  },
  setup() {
    const globalLoading = ref(0);
    const globalShowInfoError = ref(0);
    provide("globalLoading", globalLoading);
    provide("globalShowInfoError", globalShowInfoError);
    return { globalLoading, globalShowInfoError };
  },
  methods: {
    handleMedicalGuideNext() {
      if (this.hasPopUp && !this.popupAlreadyShown) {
        this.currentStep = 'POPUP';
      } else {
        this.currentStep = 'FINISHED';
      }
    },
    showPopUpModal() {

      if (this.hasPopUp && !this.popupAlreadyShown) {
        this.$nextTick(() => {
          this.$bvModal.show("communication-popup-modal");        
          this.$store.commit("setPopupAlreadyShown", true);
        });
      }
    },
    onPopupClosed(isVisible) {
      if (!isVisible) {
        this.$store.commit("setPopupAlreadyShown", true);
        this.currentStep = 'FINISHED';
      }
    },
    async getUserImage() {
      this.userImage = await getProfileImage(this.$store.getters.getUserName);
    },
    handleImageUpdate(imageLink) {
      this.userImage = imageLink;
    },
    getUser() {
      return getNameUser();
    },
    onActioHandler() {
      this.globalShowInfoError -= 1;
    },

    atualizarBadgeRecaptcha() {
      if (!this.isLoginPage) {
        document.body.classList.add("show-recaptcha");
      } else {
        document.body.classList.remove("show-recaptcha");
      }
    },
    checkTour() {
      const username = this.$store.getters.getUserName;
      if (!username) {
        setTimeout(() => this.checkTour(), 500);
        return;
      }
      
      const tourData = JSON.parse(localStorage.getItem(`tour_cooperado_${username}`)) || { seen: false, skips: 0 };

      if (!tourData.seen && tourData.skips < 3) {
        this.currentStep = 'TOUR';
        this.$nextTick(() => {
          if (this.$refs.welcomeTourModal) {
            this.$refs.welcomeTourModal.show();
          }
        });
      } else {
        this.currentStep = 'MEDICAL_GUIDE'; 
      }
    },
    onStartTour() {      
      startGuidedTour(
        () => {
          const username = this.$store.getters.getUserName;
          if (!username) return;

          let tourData = JSON.parse(localStorage.getItem(`tour_cooperado_${username}`)) || { seen: false, skips: 0 };
          // Define as seen only if it was not seen before 
          // If finished cleanly or skipped by ESC inside the tour, we mark it as seen so it doesn't bother again
          tourData.seen = true;
          localStorage.setItem(`tour_cooperado_${username}`, JSON.stringify(tourData));
          this.currentStep = 'MEDICAL_GUIDE'; 
        },
        () => {
          // Usuário pressionou "Voltar" no primeiro passo → reabre o modal de boas-vindas
          this.$nextTick(() => {
            if (this.$refs.welcomeTourModal) {
              this.$refs.welcomeTourModal.show();
            }
          });
        }
      );
    },
    onSkipTour() {
      const username = this.$store.getters.getUserName;
      if (!username) return;
      
      let tourData = JSON.parse(localStorage.getItem(`tour_cooperado_${username}`)) || { seen: false, skips: 0 };
      tourData.skips += 1;
      localStorage.setItem(`tour_cooperado_${username}`, JSON.stringify(tourData));
      this.currentStep = 'MEDICAL_GUIDE';
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.chat-whatsapp-floating {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 9997;
}

.cards {
  width: 100%;
  display: grid;
  border-style: none;
  grid-column: 0;
}

.info-crm {
  display: grid;
  grid-template-columns: 240px 30px;
}

.input-file-adm {
  border: none;
}

.config-img-adm {
  cursor: pointer;
}

@media only screen and (max-width: 600px) {
  .chat-whatsapp-floating {
    bottom: 70px !important;
  }
}

.grecaptcha-badge {
  margin-bottom: 0px;
}

body.show-recaptcha .grecaptcha-badge {
  margin-bottom: 100px;
}
</style>
